module.exports = __webpack_public_path__ + "media/icons/money-c77afe0e.svg";